export const DRY = 'dry';
export const WET = 'wet';

export const soilProcessingTypes = [DRY, WET];
